import { ContentWrapper } from '@/components/_common';
import { HelpItem } from '@/core/domain/helpcenter/HelpItems/HelpItems.types';
import { Col, Row, Skeleton, Typography, Empty } from 'antd';
import React from 'react';
import genericThumb3 from '@/assets/images/generic_thumb_3.png';
import './style.less';
import { useWindowSize } from '@/hooks';
import { Link } from 'react-router-dom';
import HelpCenterFavoriteToggle from '../HelpCenterFavoriteToogle';

interface Props {
  loading?: boolean;
  items?: HelpItem[];
}

const { Text, Title } = Typography;

const HelpCenterItemsContent: React.FC<Props> = ({
  loading = false,
  items,
}) => {
  const { isMobile } = useWindowSize();

  function handleRedirectLink(item: HelpItem) {
    if (item?.link) window.open(item.link, '_blank');
  }

  return (
    <>
      {items?.length ? (
        <Skeleton loading={loading}>
          <Row gutter={[24, 24]}>
            {items?.map((item) => (
              <Col key={item.id} span={24}>
                <ContentWrapper style={{ padding: 24 }}>
                  <Row gutter={[24, 24]}>
                    {isMobile && (
                      <Col span={24}>
                        <Link to={`/helpCenter/${item.area.id}/${item.id}`}>
                          <Title level={4}>{item.title}</Title>
                        </Link>
                      </Col>
                    )}

                    <Col span={24} md={8}>
                      <Link to={`/helpCenter/${item.area.id}/${item.id}`}>
                        <img
                          src={item.thumbnail || genericThumb3}
                          style={{
                            width: '100%',
                            height: 200,
                            objectFit: 'cover',
                            borderRadius: 8,
                            display: 'block',
                          }}
                        />
                      </Link>
                    </Col>

                    <Col span={24} md={12} xxl={10}>
                      {!isMobile && (
                        <Title style={{ marginTop: 0 }} level={3}>
                          <Link to={`/helpCenter/${item.area.id}/${item.id}`}>
                            {item.title}
                          </Link>
                        </Title>
                      )}

                      <Row gutter={[12, 12]}>
                        <Col span={24}>
                          <Text
                            style={{ marginTop: 24 }}
                            onClick={() => handleRedirectLink(item)}
                          >
                            {item.content.slice(0, 300)}...
                          </Text>
                        </Col>

                        <Col span={24} lg={12}>
                          <HelpCenterFavoriteToggle helpItem={item} />
                        </Col>
                      </Row>

                      <div></div>
                    </Col>
                  </Row>
                </ContentWrapper>
              </Col>
            ))}
          </Row>
        </Skeleton>
      ) : (
        <Skeleton loading={loading}>
          <ContentWrapper style={{ marginBottom: 24 }}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Empty description="Vídeo em Breve! Mas, não fique de fora. Entre em contato com nosso Comercial!" />
              </Col>
            </Row>
          </ContentWrapper>
        </Skeleton>
      )}
    </>
  );
};

export default HelpCenterItemsContent;
